// in src/posts.js
import React from 'react';
import { Filter, DeleteButton, DateField, RichTextField, SimpleShowLayout, Show, ShowButton, SimpleList, BooleanInput, List, Edit, Create, Datagrid, ReferenceField, TextField, EditButton, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { useMediaQuery } from '@mui/material';
//Utils
import Validators from './renderFields/validatorsFields';

const PqrFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="title" alwaysOn />
    </Filter>
);

export const PqrList = (props) => {
    // Check if the screen size is small
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <List {...props} title="Categorias - PQRS" filters={<PqrFilter />}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.title}
                    secondaryText={record => record.content}
                    tertiaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="title" label="Título" />
                    <TextField source="content" label="Descripción" />
                    <EditButton />
                    <ShowButton />
                    <DeleteButton />
                </Datagrid>
            )}
        </List>
    );
};

const PqrTitle = ({ record }) => {
    return <span>PQRS {record ? `"${record.title}"` : ''}</span>;
};

export const PqrEdit = (props) => (
    <Edit title={<PqrTitle />} {...props}>
        <SimpleForm>
            <TextInput source="id" disabled/>
            <TextInput source="title" label="Título" validate={[Validators.required]}/>
            <TextInput source="content" label="Descripción" validate={[Validators.required]} miltiline/>
            <BooleanInput source="state" label="Estado"/>
        </SimpleForm>
    </Edit>
);

export const PqrCreate = (props) => (
    <Create {...props} title="Crear PQRS">
        <SimpleForm>
            <TextInput source="title" label="Título" validate={[Validators.required]}/>
            <TextInput source="content" label="Descripción" validate={[Validators.required]} multiline/>
            <BooleanInput source="state" label="Estado" defaultValue={true}/>
        </SimpleForm>
    </Create>
);

export const PqrShow = (props) => (
    <Show title={<PqrTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="title" label="Título"/>
            <RichTextField source="content" label="Descripción"/>
            <DateField label="Fecha de Publicación" source="createdAt" />
        </SimpleShowLayout>
    </Show>
);
